export default "__VITE_ASSET__Bbo3jx33__"